import { useParams, createAsync, query } from "@solidjs/router";
import { RIASRecordType } from "~/lib/types";

import { subscriptionsQuery } from "./CertifierSubscriptions";
import { formattedTimestamp } from "~/lib";

const { getByUser } = await import( "~/_server/dynamoDB" );

const certificatesQuery = query( async ( userId: number ) => {
	"use server";

	return await getByUser( RIASRecordType.CERTIFICATE, userId, -1 );
}, "getCertifierCertificates" );


export const CertifierSummary = () => {
	const { id } = useParams();

	const certificates = createAsync( () => certificatesQuery( parseInt( id ?? "0" ) ).then( r => r.items ?? [] ) );

	const subscriptions = createAsync( () => subscriptionsQuery( parseInt( id ?? "0" ) ).then( r => r.items ?? [] ) );

	const recentCert = () => ( certificates()?.[0]?.created ? certificates()?.[0]?.created * 1000 : 0 );

	const memberSince = () =>
		( subscriptions()?.reduce( ( min, item ) =>
			item.joined * 1000 < min ? item.joined * 1000 : min, Date.now()  ) ) ?? 0 * 1000;


	return (
		<>
			<div>
				<p class="text-[10.5px] text-text-3 uppercase tracking-wider mb-2">Assessment status</p>
				<div class="flex flex-col gap-1.5">
					<div class="flex justify-between items-center text-[13px] text-text-2">
						<span>Domestic</span>
						<span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-[11.5px] font-medium bg-green-200 text-green-700">Passed</span>
					</div>
					<div class="flex justify-between items-center text-[13px] text-text-2">
						<span>Non-domestic</span>
						<span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-[11.5px] font-medium bg-red-200 text-red-800">Failed</span>
					</div>
				</div>
			</div>

			<hr class="h-px border-gray-400 my-4" />

			<div class="grid grid-cols-2 gap-2.5">
				<div class="bg-bg-muted rounded-lg px-3.5 py-3">
					<p class="text-[10.5px] text-text-3 uppercase tracking-wider mb-1">Member since</p>
					<p class="text-4xl text-black font-bold">{formattedTimestamp( memberSince(), { month: "short", year: "numeric" } )}</p>
				</div>
				<div class="bg-bg-muted rounded-lg px-3.5 py-3 text-center">
					<p class="text-[10.5px] text-text-3 uppercase tracking-wider mb-1">Certificates</p>
					<p class="text-4xl text-black font-bold leading-tight">{certificates()?.length ?? 'n/a'}</p>
					<p class="text-[11px] text-text-3 mt-0.5">Most recent {formattedTimestamp( recentCert(), { month: "short", year: "numeric" } )}</p>
				</div>
			</div>

			<hr class="h-px border-gray-400 my-4" />

			{/* Subscriptions 
			<div>
				<p class="text-[10.5px] text-text-3 uppercase tracking-wider mb-1.5">Subscriptions</p>
				<div class="flex flex-col gap-1.5">
					<a href="#" class="text-[13px] text-sky-900 no-underline hover:underline flex justify-between items-center">S6 Domestic <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></a>
					<a href="#" class="text-[13px] text-sky-900 no-underline hover:underline flex justify-between items-center">S6 Non-domestic <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></a>
				</div>
			</div>
			*/}
		</>
	)
}